(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-origin"] && !Shopify.designMode) return;
  try {
    
	const announcementHeight = () => {
		// Select all elements
		const announcements = document.querySelectorAll(
			'.shopify-section-group-header-group.section-announcement'
		);

		if (announcements.length === 0) {
			return;
		}

		// Initialize the variable to store the total height
		let announcementHeight = 0;

		// Iterate over each element and add its height to the total
		announcements.forEach((announcement) => {
			const height = announcement.offsetHeight; // Get the height of the element
			announcementHeight += height; // Add it to the total
		});

		document.documentElement.style.setProperty(
			'--announcement-height',
			`${announcementHeight}px`
		);
		return announcementHeight;
	};

	announcementHeight();

	const iconClose = () => {
		const icons = document.querySelectorAll(".icon-close");
		icons.forEach((icon) => {
			icon.addEventListener("click", function () {
				const announcement = icon.closest(".section-announcement");
				if (announcement) {
					announcement.style.display = "none";
				}
				announcementHeight();
			});
		});
	};

	iconClose();

	document.addEventListener('shopify:section:load', function () {
		announcementHeight();
		iconClose();
	});
	window.addEventListener('resize', announcementHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
	const announcementHeight = () => {
		const announcements = document.querySelectorAll(
			'.shopify-section-group-header-group.section-announcement'
		);
		if (announcements.length === 0) return;

		let totalHeight = 0;
		announcements.forEach((el) => {
			totalHeight += el.offsetHeight;
		});
		document.documentElement.style.setProperty('--announcement-height', `${totalHeight}px`);
		return totalHeight;
	};

	const iconClose = () => {
		document.querySelectorAll('.announcement-bar__close-btn').forEach((btn) => {
			btn.addEventListener('click', function () {
				const announcement = btn.closest('.section-announcement');
				if (announcement) announcement.style.display = 'none';
				announcementHeight();
			});
		});
	};

	const initAnnouncementSlider = (slider) => {
		if (!slider || slider.dataset.sliderInit) return;
		slider.dataset.sliderInit = 'true';

		const track = slider.querySelector('.announcement-track');
		const slides = Array.from(slider.querySelectorAll('.announcement-slide'));
		if (slides.length <= 1) return;

		const count = slides.length;
		const speed = parseInt(slider.dataset.speed, 10) || 5000;
		const transition = slider.dataset.transition || 'slide';

		// スライドモードのみ: 先頭・末尾にクローンを挿入してループを実現
		if (transition === 'slide') {
			const cloneFirst = slides[0].cloneNode(true);
			const cloneLast = slides[count - 1].cloneNode(true);
			// Shopifyエディタ属性はクローンには不要
			cloneFirst.removeAttribute('data-shopify-editor-block');
			cloneLast.removeAttribute('data-shopify-editor-block');
			track.appendChild(cloneFirst);
			track.insertBefore(cloneLast, slides[0]);
		}

		let current = 0;  // real index (0 〜 count-1)
		let domPos = transition === 'slide' ? 1 : 0;  // DOM上の位置（clone分+1）
		let timer = null;

		const setPos = (pos, animated) => {
			track.style.transition = animated ? 'transform 0.5s ease' : 'none';
			track.style.transform = `translateX(-${pos * 100}%)`;
		};

		if (transition === 'slide') setPos(1, false);

		const advanceDom = (targetDomPos) => {
			if (transition !== 'slide') {
				const next = (current + (targetDomPos > domPos ? 1 : -1) + count) % count;
				slides[current].classList.remove('is-active');
				slides[next].classList.add('is-active');
				current = next;
				return;
			}

			setPos(targetDomPos, true);
			domPos = targetDomPos;

			if (targetDomPos > count) {
				// clone of first に到達 → 瞬時に real first へジャンプ
				track.addEventListener('transitionend', function onEnd(e) {
					if (e.propertyName !== 'transform') return;
					track.removeEventListener('transitionend', onEnd);
					track.style.transition = 'none';
					track.style.transform = `translateX(-100%)`;
					void track.offsetWidth; // 強制リフロー
					current = 0;
					domPos = 1;
				}, { once: true });
			} else if (targetDomPos < 1) {
				// clone of last に到達 → 瞬時に real last へジャンプ
				track.addEventListener('transitionend', function onEnd(e) {
					if (e.propertyName !== 'transform') return;
					track.removeEventListener('transitionend', onEnd);
					track.style.transition = 'none';
					track.style.transform = `translateX(-${count * 100}%)`;
					void track.offsetWidth; // 強制リフロー
					current = count - 1;
					domPos = count;
				}, { once: true });
			} else {
				current = targetDomPos - 1;
			}
		};

		const advance = () => advanceDom(domPos + 1);
		const start = () => { timer = setInterval(advance, speed); };
		const stop = () => clearInterval(timer);

		// ── ドラッグ／スワイプ ──
		let dragStartX = 0;
		let dragging = false;
		const THRESHOLD = 50;

		const onDragStart = (x) => {
			dragStartX = x;
			dragging = true;
			stop();
			if (transition === 'slide') track.style.transition = 'none';
		};

		const onDragMove = (x) => {
			if (!dragging || transition !== 'slide') return;
			const diff = x - dragStartX;
			track.style.transform = `translateX(calc(-${domPos * 100}% + ${diff}px))`;
		};

		const onDragEnd = (x) => {
			if (!dragging) return;
			dragging = false;
			const diff = x - dragStartX;
			if (Math.abs(diff) >= THRESHOLD) {
				advanceDom(diff < 0 ? domPos + 1 : domPos - 1);
			} else {
				if (transition === 'slide') {
					track.style.transition = 'transform 0.5s ease';
					track.style.transform = `translateX(-${domPos * 100}%)`;
				}
			}
			start();
		};

		// mouse
		slider.addEventListener('mousedown', (e) => onDragStart(e.clientX));
		window.addEventListener('mousemove', (e) => { if (dragging) onDragMove(e.clientX); });
		window.addEventListener('mouseup', (e) => { if (dragging) onDragEnd(e.clientX); });

		// touch
		slider.addEventListener('touchstart', (e) => onDragStart(e.touches[0].clientX), { passive: true });
		slider.addEventListener('touchmove', (e) => {
			if (!dragging) return;
			if (Math.abs(e.touches[0].clientX - dragStartX) > 5) e.preventDefault();
			onDragMove(e.touches[0].clientX);
		}, { passive: false });
		slider.addEventListener('touchend', (e) => onDragEnd(e.changedTouches[0].clientX));

		slider.addEventListener('mouseenter', stop);
		slider.addEventListener('mouseleave', () => { if (!dragging) start(); });

		start();
	};

	const initAllSliders = () => {
		document.querySelectorAll('.announcement-slider').forEach(initAnnouncementSlider);
	};

	announcementHeight();
	iconClose();
	initAllSliders();

	document.addEventListener('shopify:section:load', function () {
		announcementHeight();
		iconClose();
		initAllSliders();
	});

	window.addEventListener('resize', announcementHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const accountModal = document.getElementById("account-modal");
  const openButtons = document.querySelectorAll(".header__icon--account");
  const closeButton = document.getElementById("account-modal-close");
  const overlay = document.getElementById("accountModal-Overlay");

  if (!accountModal) return;

  function openModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    accountModal.classList.add("active");
    document.body.classList.add("overflow-hidden");
  }

  function closeModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
    accountModal.classList.remove("active");
    document.body.classList.remove("overflow-hidden");

    const header = document.querySelector(".shopify-section-header");
    if (header) {
      header.classList.remove("animate", "shopify-section-header-sticky");
    }
  }

  openButtons.forEach((button) => {
    button.addEventListener(
      "click",
      function (e) {
        if (accountModal.classList.contains("active")) {
          closeModal(e);
        } else {
          openModal(e);
        }
      },
      true
    );
  });

  if (closeButton) {
    closeButton.addEventListener(
      "click",
      function (e) {
        closeModal(e);
      },
      true
    );
  }

  if (overlay) {
    overlay.addEventListener(
      "click",
      function (e) {
        closeModal(e);
      },
      true
    );
  }

  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key === "Escape" && accountModal.classList.contains("active")) {
        closeModal(e);
      }
    },
    true
  );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
					const initSlider = () => {
						document
							.querySelectorAll(".js-recommendation-swiper")
							.forEach((elem, index) => {
								let slider = new Swiper(elem, {
									slidesPerView: 1,
									spaceBetween: 0,
									speed: 600,
									navigation: {
										nextEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-next"
										),
										prevEl: elem.querySelector(
											".product-recommendations__slider-nav .swiper-button-prev"
										),
									},
								});
							});
					};
					initSlider()
				})
				.catch(e => {
					console.error(e);
				});
				
		}
		
		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						const initProductSlider = () => {
							var swiper = new Swiper('.swiper-container', {
								slidesPerView: 1,

								spaceBetween: 0,
								navigation: {
									nextEl: '.product-button-group .swiper-button-next-1',
									prevEl: '.product-button-group .swiper-button-prev-1',
								},
							});
						};

						initProductSlider();
						buttonHoverEffects();
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
